<template>
    <div v-loading="tableLoading">
        <div style="margin-top: 15px;">
            <el-table class="factory-table" ref="multipleTable" :data="tableData" style="width: 100%" element-loading-text="数据正在加载中" @selection-change="handleSelectionChange" :header-cell-style="headClass" :row-style="rowClass">
                >
                <el-table-column type="selection" width="60"></el-table-column>
                <el-table-column prop="nid" label="nid"></el-table-column>
                <el-table-column prop="hsn" label="硬件序列号"></el-table-column>
                <el-table-column label="是否在线">
                    <template slot-scope="scope">
                        <el-row type="flex" style="margin-right: 10px;margin-left: 10px">
                            <div v-if="scope.row.online" style="background-color: limegreen;width: 10px;height:10px;border-radius: 50%"></div>
                            <div v-else style="background-color: #cd0000;width: 10px;height:10px;border-radius: 50%"></div>
                        </el-row>
                    </template>
                </el-table-column>
                <el-table-column label="运行状态">
                    <template slot-scope="scope">
                        <div v-if="scope.row.status">
                            <i class="el-icon-sunny" style="color:orange"></i>
                        </div>
                        <div v-else>
                            <i class="el-icon-moon" style="color:blue"></i>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="详情">
                    <template slot-scope="scope">
                        <button @click="showDetails(scope.row.nid)">详情</button>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <button @click="waterDialogVisible=true;curnid=scope.row.nid;curhsn='操作设备：'+scope.row.hsn">出水</button>
                        <button @click="controlDialogVisible=true;curnid=scope.row.nid;curhsn='操作设备：'+scope.row.hsn">控制</button>
                        <button @click="setparamDialogVisible=true;curnid=scope.row.nid;curhsn='操作设备：'+scope.row.hsn">设置参数</button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background style="text-align:right;margin-top: 15px;margin-bottom: 55px;" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 50, 100, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
        <el-dialog :visible.sync="detailsDialogVisible" width="70%" :close-on-click-modal="false">
            <!-- <span v-html="detailsHtml"></span> -->
            <h3>配置信息</h3>
            <span v-for="(item,key) in configInfo" style="width: 50%;display: inline-block;">{{ key }} ： {{ item }}</span>
            <h3>统计信息</h3>
            <span v-for="(item,key) in statisticalInfo" style="width: 50%;display: inline-block;">{{ key }} ： {{ item }}</span>
            <h3>运行信息</h3>
            <span v-for="(item,key) in runtimeInfo" style="width: 50%;display: inline-block;">{{ key }} ： {{ item }}</span>
            <h3>GSM信息</h3>
            <span v-for="(item,key) in gsmInfo" style="width: 50%;display: inline-block;">{{ key }} ： {{ item }}</span>
        </el-dialog>
        <el-dialog :title="curhsn" :visible.sync="waterDialogVisible" width="450px" :close-on-click-modal="false">
            <el-form :model="waterForm">
                <el-form-item label="出水状态">
                    <el-input v-model="waterForm.outState"></el-input>
                </el-form-item>
                <el-form-item label="出水温度">
                    <el-input v-model="waterForm.outTemp"></el-input>
                </el-form-item>
                <el-form-item label="出水量">
                    <el-input v-model="waterForm.outFlow"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="waterOut()" :loading="waterLoading">出水</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="curhsn" :visible.sync="controlDialogVisible" width="600px" :close-on-click-modal="false">
            <el-button v-for="item in buttonData" type="primary" style="margin: 5px;width:130px" @click="control(item.action)" :key="item.action">{{item.label}}</el-button>
        </el-dialog>
        <el-dialog :title="curhsn" :visible.sync="setparamDialogVisible" width="550px" :close-on-click-modal="false">
            <el-row :gutter="10">
                <el-col :span="8">
                    <el-select v-model="setParamAction" placeholder="请选择">
                        <el-option v-for="item in selectParamDate" :key="item.action" :label="item.label" :value="item.action"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="12">
                    <el-input v-model="paramValue" placeholder></el-input>
                </el-col>
                <el-col :span="4">
                    <el-button type="primary" @click="setparam()" :loading="paramLoading">确定</el-button>
                </el-col>
            </el-row>
        </el-dialog>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        name: 'desktopWaterPurifierMng',
        data() {
            return {
                curnid: 0,
                curhsn: '',
                selectValue: '',
                queryValue: '',
                time: [],
                tableData: [],
                detailsDialogVisible: false,
                controlDialogVisible: false,
                setparamDialogVisible: false,
                waterDialogVisible: false,
                tableLoading: false,
                configInfo: {},
                statisticalInfo: {},
                runtimeInfo: {},
                gsmInfo: {},
                buttonData: [{
                        label: "开机",
                        action: 1
                    },
                    {
                        label: "关机",
                        action: 2
                    },
                    {
                        label: "锁定",
                        action: 3
                    },
                    {
                        label: "恢复出厂设置",
                        action: 5
                    },
                    {
                        label: "冲洗",
                        action: 6
                    },
                    {
                        label: "童锁",
                        action: 23
                    },
                    {
                        label: "滤芯 全清",
                        action: 18
                    },
                    {
                        label: "滤芯A清零",
                        action: 15
                    },
                    {
                        label: "滤芯B清零",
                        action: 16
                    },
                    {
                        label: "滤芯C清零",
                        action: 17
                    },
                    {
                        label: "配置清零",
                        action: 19
                    },
                    {
                        label: "增压泵清零",
                        action: 20
                    }
                ],
                setParamAction: '',
                paramValue: '',
                paramLoading: false,
                waterLoading: false,
                selectParamDate: [{
                        label: "解锁",
                        action: 4
                    },
                    {
                        label: "滤芯A通电寿命",
                        action: 7
                    },
                    {
                        label: "滤芯B通电寿命",
                        action: 8
                    },
                    {
                        label: "滤芯C通电寿命",
                        action: 9
                    },
                    {
                        label: "滤芯A制水水量",
                        action: 10
                    },
                    {
                        label: "滤芯B制水水量",
                        action: 11
                    },
                    {
                        label: "滤芯C制水水量",
                        action: 12
                    },
                    {
                        label: "滤芯D制水水量",
                        action: 13
                    },
                    {
                        label: "滤芯E制水水量",
                        action: 14
                    },
                    {
                        label: "统计信息上报周期",
                        action: 21
                    },
                    {
                        label: "实时状态上报周期",
                        action: 22
                    },
                    {
                        label: "档位温度-沸水",
                        action: 25
                    },
                    {
                        label: "档位温度-泡茶",
                        action: 26
                    },
                    {
                        label: "档位温度-牛奶",
                        action: 27
                    },
                    {
                        label: "档位温度-咖啡",
                        action: 28
                    },
                    {
                        label: "童锁使能",
                        action: 24
                    }
                ],
                total: 0,
                currentPage: 1,
                pageSize: 10,
                multipleSelection: [],
                waterForm: {
                    outState: 0,
                    outTemp: 0,
                    outFlow: 0
                }
            }
        },
        computed: {
            isInput: function() {
                if (this.selectValue != '4') {
                    this.queryValue = ''
                    return true
                } else {
                    this.time = [];
                    return false
                }
            },
        },
        mounted() {
            this.updateTable();
        },
        methods: {
            handleSelectionChange(val) {
                if (val.length > 1) {
                    //设置单选
                    this.$refs.multipleTable.clearSelection();
                    this.$refs.multipleTable.toggleRowSelection(val.pop());
                }
                this.multipleSelection = val
            },
            handleSizeChange(val) {
                this.pageSize = val
                this.updateTable()
            },
            handleCurrentChange(val) {
                this.currentPage = val
                this.updateTable()
            },
            rowClass({
                row,
                rowIndex
            }) {
                if (rowIndex % 2 == 0) {
                    return 'background:#F1F2F7;'
                } else {
                    return 'background:white;'
                }
                return ''
            },
            headClass({
                row,
                rowIndex
            }) {
                if (rowIndex == 0) {
                    return ''
                }
                return ''
            },
            getStandardDate(val) {
                var year = val.getFullYear()
                var month = val.getMonth() + 1
                var day = val.getDate()
                month = month < 10 ? '0' + month : month
                day = day < 10 ? '0' + day : day
                return year + '-' + month + '-' + day
            },
            waterOut() {
                var thiz = this;
                thiz.waterLoading = true;
                axios
                    .get(this.$store.getters.getApiValue + '/market/smart/water.do', {
                        params: {
                            nid: thiz.curnid,
                            status: thiz.waterForm.outState,
                            temp: thiz.waterForm.outTemp,
                            water: thiz.waterForm.outFlow,
                            sync: true
                        }
                    })
                    .then(function(response) {
                        thiz.waterLoading = false;
                        var data = response.data
                        if (data.status == '200') {
                            if (data.data === 'success') {
                                thiz.$message.success("操作成功");
                            } else {
                                thiz.$message.error("操作失败");
                            }
                        } else {
                            thiz.$message.error(data.message)
                        }
                    })
                    .catch(function(error) {
                        thiz.waterLoading = false;
                        console.log(error)
                        thiz.$message.error('系统异常!请与管理员联系!')
                    })
            },
            setparam() {
                var thiz = this;
                if (thiz.setParamAction == '') {
                    thiz.$message.error("请选择待设置的项目");
                    return false;
                }
                if (thiz.paramValue == '') {
                    thiz.$message.error("值不能为空");
                    return false;
                }
                thiz.paramLoading = true;
                axios
                    .get(this.$store.getters.getApiValue + '/market/smart/operate.do', {
                        params: {
                            nid: thiz.curnid,
                            action: thiz.setParamAction,
                            actionValueStr: thiz.paramValue,
                            sync: true
                        }
                    })
                    .then(function(response) {
                        thiz.paramLoading = false;
                        var data = response.data
                        if (data.status == '200') {
                            if (data.data === 'success') {
                                thiz.$message.success("操作成功");
                            } else {
                                thiz.$message.error("操作失败");
                            }
                        } else {
                            thiz.$message.error(data.message)
                        }
                    })
                    .catch(function(error) {
                        thiz.paramLoading = false;
                        console.log(error)
                        thiz.$message.error('系统异常!请与管理员联系!')
                    })
            },
            control(action) {
                var thiz = this;
                const loading = this.$loading({
                    lock: true,
                    text: '操作执行中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
                axios
                    .get(this.$store.getters.getApiValue + '/market/smart/operate.do', {
                        params: {
                            nid: thiz.curnid,
                            action: action,
                            sync: true
                        }
                    })
                    .then(function(response) {
                        loading.close()
                        var data = response.data
                        if (data.status == '200') {
                            if (data.data === 'success') {
                                thiz.$message.success("操作成功");
                            } else {
                                thiz.$message.error("操作失败");
                            }
                        } else {
                            thiz.$message.error(data.message)
                        }
                    })
                    .catch(function(error) {
                        loading.close()
                        console.log(error)
                        thiz.$message.error('系统异常!请与管理员联系!')
                    })
            },
            showDetails(nid) {
                var thiz = this;
                axios
                    .get(this.$store.getters.getApiValue + '/market/smart/info.do', {
                        params: {
                            nid: nid
                        }
                    })
                    .then(function(response) {
                        var data = response.data
                        if (data.status == '200') {
                            thiz.configInfo = data.data.configInfo;
                            thiz.statisticalInfo = data.data.statisticalInfo;
                            thiz.runtimeInfo = data.data.runtimeInfo;
                            thiz.gsmInfo = data.data.gsmInfo;
                            thiz.detailsDialogVisible = true;
                        } else {
                            thiz.$message.error(data.message)
                        }
                    })
                    .catch(function(error) {
                        console.log(error)
                        thiz.$message.error('系统异常!请与管理员联系!')
                    })
            },
            updateTable() {
                this.tableLoading = true;
                var thiz = this
                var params = {
                    pageId: this.currentPage,
                    size: this.pageSize,
                    ntId: 1036
                }
                axios
                    .get(this.$store.getters.getApiValue + '/admin/smart/list.do', {
                        params: params
                    })
                    .then(function(response) {
                        var data = response.data
                        if (data.status == '200') {
                            thiz.total = data.totalCount
                            thiz.tableData = data.data
                        } else {
                            thiz.$message.error(data.message)
                        }
                    })
                    .catch(function(error) {
                        console.log(error)
                        thiz.$message.error('系统异常!请与管理员联系!')
                    })
                    .finally(() => {
                        this.tableLoading = false
                    })
            }
        }
    }
</script>

<style>
    .valueTable {
        width: 180px;
        border-top: 1px solid #e7eaec;
        padding: 5px;
    }

    .infoTable {
        color: #000000;
        width: 120px;
        font-size: 14px;
        border-top: 1px solid #e7eaec;
    }
</style>

<style scoped>
    .factory-table {
        font-size: 12px;
    }
</style>